import { Container } from '@mui/material';
import { CSSProperties, PropsWithChildren } from 'react';
import styled from 'styled-components';

type MarginTop = 'small' | 'medium' | 'large';

const PAGE_MARGIN_TOP: Record<MarginTop, string> = {
	small: '0.5rem',
	medium: '1rem',
	large: '2rem'
};

export const PageWrapper = styled.div<{ $marginTop?: MarginTop; $overflow?: string }>`
	width: 100%;
	height: 100%;
	position: relative;
	display: inline-block;
	overflow: ${props => props.$overflow || undefined};
	margin-top: ${props => (props.$marginTop ? PAGE_MARGIN_TOP[props.$marginTop] : undefined)};
	background-color: ${props => props.theme.palette.background['paper-elevation-0']};
`;

export type PageProps = PropsWithChildren<{
	fullscreen?: boolean;
	/** marginTop - used in case if we want extra page margin. Our page by default
	 * has margin 0 - designed to stay all the way up & take all available space */
	marginTop?: MarginTop;
	backgroundColor?: CSSProperties['backgroundColor'];
	overflow?: CSSProperties['overflow'];
}>;

export const Page: React.FC<PageProps> = props => {
	return props.fullscreen ? (
		<PageWrapper $overflow={props.overflow} $marginTop={props.marginTop}>
			{props.children}
		</PageWrapper>
	) : (
		<PageWrapper $overflow={props.overflow} $marginTop={props.marginTop}>
			<Container sx={{ height: '100%' }} maxWidth="xl">
				{props.children}
			</Container>
		</PageWrapper>
	);
};
